module.exports = __webpack_public_path__ + "static/media/12.1b1c3d5d.jpeg";